import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  Drawer,
  Select,
  Spin,
  Button,
  Table as AntTable,
  Input,
  Modal,
} from "antd";
import {
  getApiBaseUrl,
  GETMASTERSREASONS,
  GETMASTERSPRESSURE,
  UPDATEFILTERSTATUS,
  ADD_ACTIVITY,
  LOGIN,
} from "../../Config/Config";

const { Option } = Select;
const { TextArea } = Input;

const BulkUpdateOffcanvas = ({
  selectedIds,
  setSelectedIds,
  fetchFilters,
  setFiltersData,
  setLoadingFilters,
  selectedBlock,
  setIsManualOverride,
  visible,
  onClose,
}) => {
  const [bulkStatus, setBulkStatus] = useState("");
  const [bulkFormData, setBulkFormData] = useState([]);
  const [washingEquipments, setWashingEquipments] = useState([]);
  const [dryerEquipmentOptions, setDryerEquipmentOptions] = useState([]);
  const [washingReasons, setWashingReasons] = useState([]);
  const [airPressureRange, setAirPressureRange] = useState({ min: 0, max: 0 });
  const [roPressureRange, setRoPressureRange] = useState({ min: 0, max: 0 });
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isReauthModalVisible, setIsReauthModalVisible] = useState(false);
  const [reauthPassword, setReauthPassword] = useState("");
  const [reauthLoading, setReauthLoading] = useState(false);
  const [isReauthenticated, setIsReauthenticated] = useState(false);
  const [deviationMessage, setDeviationMessage] = useState("");

  const [commonFields, setCommonFields] = useState({
    washingEquipId: null,
    washingReasonId: null,
    RoWaterPressure: "",
    DryerEquipId: null,
    Duration: null,
    AirPressure: "",
  });

  const processOrderMapping = {
    "Wash In": 1,
    "Wash Out": 2,
    "Dry In": 3,
    "Dry Out": 4,
    "Storage-In": 5,
    "Storage-Out": 6,
  };

  const stageNameMapping = {
    0: "New/Spare",
    1: "Wash In",
    2: "Wash Out",
    3: "Dry In",
    4: "Dry Out",
    5: "Storage-In",
    6: "Storage-Out",
  };

  const auditLogDescription = {
    "Wash In": "Washing In Process",
    "Wash Out": "Washing Out Process",
    "Dry In": "Drying In Process",
    "Dry Out": "Drying Out Process",
    "Storage-In": "Storage In Process",
    "Storage-Out": "Storage Out Process",
  };

  const [newEquipmentsData, setNewEquipmentsData] = useState([]);
  const [newAirPressure, setNewAirPressure] = useState(null);
  const [newWaterPressure, setNewWaterPressure] = useState(null);
  const [newTemperature, setNewTemperature] = useState(null);

  const fetchData = async () => {
    if (!selectedBlock) return;
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getPressureByBlock?blockId=${selectedBlock}`
      );
      const data = await res.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        // Equipments (Type = 0)
        const equipments = data.ResultData.filter(
          (item) => item.Type === 0
        ).map((item) => ({
          Id: item.EquipmentId, // Map EquipmentId to Id for compatibility
          EquipmentName: item.Name,
          SerialNumber: item.EquipmentId, // Use EquipmentId as SerialNumber for consistency
          BlockId: item.BlockId,
        }));

        // Pressures & Temperature
        const air = data.ResultData.find((item) => item.Type === 1);
        const water = data.ResultData.find((item) => item.Type === 2);
        const temp = data.ResultData.find((item) => item.Type === 3);

        setNewEquipmentsData(equipments);
        setWashingEquipments(equipments); // Use same equipment list
        setDryerEquipmentOptions(equipments); // Use same equipment list

        if (air) {
          setNewAirPressure({
            min: air.Min,
            max: air.max,
            unit: air.Unit,
            name: air.Name,
          });
          setAirPressureRange({ min: air.Min, max: air.max }); // Update airPressureRange
        }

        if (water) {
          setNewWaterPressure({
            min: water.Min,
            max: water.max,
            unit: water.Unit,
            name: water.Name,
          });
          setRoPressureRange({ min: water.Min, max: water.max }); // Update roPressureRange
        }

        if (temp) {
          setNewTemperature({
            min: temp.Min,
            max: temp.max,
            unit: temp.Unit,
            name: temp.Name,
          });
        }
      } else {
        console.warn("Invalid data from getPressureByBlock:", data);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedBlock]);

  console.log(
    newWaterPressure,
    newAirPressure,
    newEquipmentsData,
    newTemperature
  );

  const generatePressureOptions = (min, max, unit) => {
    if (!min || !max || !unit) return [];
    const options = [];
    for (let val = min; val <= max; val += 0.1) {
      const fixedVal = parseFloat(val.toFixed(1));
      if (fixedVal <= max) {
        options.push({
          value: fixedVal.toString(),
          label: `${fixedVal} ${unit}`,
        });
      }
    }
    return options;
  };

  const pressureOptions = generatePressureOptions(
    newWaterPressure?.min || roPressureRange.min,
    newWaterPressure?.max || roPressureRange.max,
    newWaterPressure?.unit || "bar"
  );
  const airPressureSelectOptions = generatePressureOptions(
    newAirPressure?.min || airPressureRange.min,
    newAirPressure?.max || airPressureRange.max,
    newAirPressure?.unit || "bar"
  );

  // Fetch air pressure range (fallback if newAirPressure is not set)
  useEffect(() => {
    if (newAirPressure) return; // Skip if already set by fetchData
    fetch(`${getApiBaseUrl()}${GETMASTERSPRESSURE}?Type=0`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.Status && data?.ResultData?.length > 0) {
          const { Min, max } = data.ResultData[0];
          setAirPressureRange({ min: Min, max });
          console.log("Air pressure range fetched:", { min: Min, max });
        } else {
          console.warn("Invalid air pressure range data:", data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch air pressure range:", err);
      });
  }, [newAirPressure]);

  // Fetch RO pressure range (fallback if newWaterPressure is not set)
  useEffect(() => {
    if (newWaterPressure) return; // Skip if already set by fetchData
    fetch(`${getApiBaseUrl()}${GETMASTERSPRESSURE}?Type=1`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.Status && data?.ResultData?.length > 0) {
          const { Min, max } = data.ResultData[0];
          setRoPressureRange({ min: Min, max });
          console.log("RO pressure range fetched:", { min: Min, max });
        } else {
          console.warn("Invalid RO pressure range data:", data);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch RO pressure range:", err);
      });
  }, [newWaterPressure]);

  // Fetch washing reasons
  useEffect(() => {
    if (bulkStatus === "Wash In") {
      fetch(`${getApiBaseUrl()}${GETMASTERSREASONS}?Type=2`)
        .then((res) => res.json())
        .then((data) => {
          if (data?.Status && Array.isArray(data.ResultData)) {
            setWashingReasons(data.ResultData);
            console.log("Washing reasons fetched:", data.ResultData);
          } else {
            console.warn("Invalid washing reasons data:", data);
          }
        })
        .catch((err) => {
          console.error("Failed to load washing reasons:", err);
        });
    }
  }, [bulkStatus]);

  // Initialize bulkFormData when drawer opens
  useEffect(() => {
    if (visible && selectedIds.length > 0) {
      console.log(selectedIds, "selectttt");
      setBulkFormData(
        selectedIds.map((item) => ({
          ID: item.ID,
          FilterId: item.Lable || "",
          Barcode: item.Barcode || "",
          Remarks: item.Remarks || "",
          Status: item.Status,
          LastCleaningDate: item.LastCleaningDate,
          cleaningdays: item.cleaningdays,
          AHUId: item?.AHUId,
        }))
      );
      setCommonFields({
        washingEquipId: null,
        washingReasonId: null,
        RoWaterPressure: "",
        DryerEquipId: null,
        Duration: null,
        AirPressure: "",
      });
      setIsReauthenticated(false);
      setDeviationMessage("");
    }
  }, [visible, selectedIds]);
  console.log("Bulk Status", bulkFormData?.[0]?.Status);

  // Check stage sequence
  const checkStageSequence = async (barcode, orderNum, performedBy) => {
    console.log("Calling CheckOrderedStage with:", {
      barcode,
      orderNum,
      performedBy,
    });
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/CheckOrderedStage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          BarcodeNum: barcode,
          OrderNum: orderNum,
          PerformedBy: performedBy,
        }),
      });
      const result = await response.json();
      console.log("CheckOrderedStage response:", result);

      const isValid = result?.ResultData?.[0]?.Status === "true";
      console.log(isValid, "venky");
      const currentStage =
        stageNameMapping[bulkFormData?.[0]?.Status] || "Unknown";
      const newStage = stageNameMapping[orderNum] || "Unknown";
      const message = isValid
        ? ""
        : `Attempted transition from ${currentStage} to ${newStage} for Filter: ${barcode}`;

      return { isValid, message };
    } catch (error) {
      console.error("Error checking stage sequence:", error);
      return {
        isValid: false,
        message: `Failed to validate stage sequence for Filter: ${barcode}`,
      };
    }
  };

  // Check dryer duration for Dry Out
  const checkDryerDuration = (filter) => {
    if (
      bulkStatus !== "Dry Out" ||
      !filter.LastCleaningDate ||
      !filter.cleaningdays
    ) {
      console.log(
        "Skipping dryer duration check: Invalid status or missing data for Filter:",
        filter.FilterId
      );
      return { isValid: true, message: "" };
    }

    const lastCleaning = new Date(filter.LastCleaningDate);
    const currentTime = new Date();
    const durationDays = (currentTime - lastCleaning) / (1000 * 60 * 60 * 24);
    const minDuration = filter.cleaningdays;

    console.log("Dryer duration check for Filter:", filter?.Lable, {
      lastCleaning: filter.LastCleaningDate,
      currentTime,
      durationDays,
      minDuration,
    });

    if (durationDays < minDuration) {
      return {
        isValid: false,
        message: `Dryer duration is ${durationDays.toFixed(
          1
        )} days, less than the required ${minDuration} days for Filter: ${
          filter?.Lable
        }`,
      };
    }
    return { isValid: true, message: "" };
  };

  // Check pressure values
  const checkPressureValues = () => {
    if (bulkStatus === "Wash In" && commonFields.RoWaterPressure) {
      const pressure = parseFloat(commonFields.RoWaterPressure);
      console.log("Checking RO Water Pressure:", {
        pressure,
        min: roPressureRange.min,
        max: roPressureRange.max,
      });
      if (pressure < roPressureRange.min || pressure > roPressureRange.max) {
        return {
          isValid: false,
          message: `RO Water Pressure ${pressure} Bar is outside allowed range (${roPressureRange.min} - ${roPressureRange.max} Bar)`,
        };
      }
    }
    if (bulkStatus === "Dry In" && commonFields.AirPressure) {
      const pressure = parseFloat(commonFields.AirPressure);
      console.log("Checking Air Pressure:", {
        pressure,
        min: airPressureRange.min,
        max: airPressureRange.max,
      });
      if (pressure < airPressureRange.min || pressure > airPressureRange.max) {
        return {
          isValid: false,
          message: `Air Pressure ${pressure} Bar is outside allowed range (${airPressureRange.min} - ${airPressureRange.max} Bar)`,
        };
      }
    }
    return { isValid: true, message: "" };
  };

  // Commented out logDeviation function to resolve no-unused-vars error
  /*
  const logDeviation = async (filter, deviationType, message) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const performedBy = user?.UserID || 0;
    const payload = {
      filterId: filter.ID || 0,
      blockid: selectedBlock || 0,
      AHUId: filter?.AHUId || 0,
      Current_Stage: filter.Status || 0,
      remarks: `${deviationType}: ${message}`,
      CreatedBy: performedBy,
      New_Stage: processOrderMapping[bulkStatus] || 0,
    };

    console.log("Logging deviation for Filter:", filter.FilterId, payload);
    try {
      await fetch(`${getApiBaseUrl()}/api/addDeviations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      console.log("Deviation logged successfully for Filter:", filter.FilterId);

      const notificationPayload = {
        Title: "Deviations",
        Message: `Deviation detected for Filter ${filter.FilterId}: ${deviationType} - ${message}`,
        RoleID: 4,
      };
      console.log("Sending notification for deviation:", notificationPayload);
      const notificationResponse = await fetch(
        `${getApiBaseUrl()}/api/addNotificationsToRole`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notificationPayload),
        }
      );
      const notificationResult = await notificationResponse.json();
      if (notificationResult.Status) {
        console.log(
          "Notification sent successfully for Filter:",
          filter.FilterId,
          notificationPayload
        );
      } else {
        console.warn(
          "Notification API failed for Filter:",
          filter.FilterId,
          notificationResult
        );
      }
    } catch (error) {
      console.error(
        "Error logging deviation or sending notification for Filter:",
        filter.FilterId,
        error
      );
    }
  };
  */

  // Reauthentication handlers
  const handleAuthenticate = async (resolve) => {
    console.log("Authenticate clicked, reauthPassword:", reauthPassword);
    if (!reauthPassword.trim()) {
      Swal.fire({
        icon: "error",
        title: "Password Required",
        text: "Password is required!",
        confirmButtonColor: "#d33",
      });
      resolve(false);
      return;
    }
    setReauthLoading(true);
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const username = user?.UserName || "";
      console.log("Sending login request with:", {
        username,
        password: reauthPassword,
      });
      const response = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: reauthPassword,
        }),
      });
      const result = await response.json();
      console.log("Reauthentication response:", result);
      if (result.status) {
        setIsReauthenticated(true);
        setIsReauthModalVisible(false);
        Swal.fire({
          icon: "success",
          title: "Reauthentication Successful",
          text: "Authentication successful. Proceeding with submission.",
          confirmButtonColor: "#3085d6",
        });
        resolve(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Credentials",
          text: result.Message || "Invalid credentials",
          confirmButtonColor: "#d33",
        });

        resolve(false);
      }
    } catch (error) {
      console.error("Reauthentication error:", error);
      Swal.fire({
        icon: "error",
        title: "Reauthentication Failed",
        text: "Failed to reauthenticate. Please try again.",
        confirmButtonColor: "#d33",
      });

      resolve(false);
    } finally {
      setReauthLoading(false);
    }
  };

  const handleCancel = (resolve) => {
    console.log("Reauthentication canceled");
    setIsReauthModalVisible(false);
    resolve(false);
  };

  // Reauthentication prompt
  const promptReauthentication = async (message) => {
    console.log("Prompting reauthentication for deviation:", message);
    setIsReauthModalVisible(true);
    setReauthPassword("");
    return new Promise((resolve) => {
      window.reauthResolve = resolve;
    });
  };

  const handleBulkSubmit = async () => {
    // Initialize user data safely
    let user;
    try {
      const userData = sessionStorage.getItem("user");
      if (!userData) {
        throw new Error("User data not found in session storage");
      }
      user = JSON.parse(userData);
    } catch (error) {
      console.error("Error parsing user data:", error);
      Swal.fire({
        icon: "error",
        title: "Authentication Error",
        text: "User data is missing or invalid. Please log in again.",
        confirmButtonColor: "#d33",
      });
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: 0,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: `Bulk Update failed: ${error.message}. Filters: ${
            bulkFormData.map((f) => f?.Lable).join(", ") || "None"
          }`,
          Location: "washing",
          IsSucces: 0,
        }),
      }).catch((err) => console.error("Audit log error (User Parsing):", err));
      return;
    }

    if (bulkFormData.length === 0 || !bulkStatus) {
      Swal.fire({
        icon: "warning",
        title: !bulkStatus ? "No Status Selected" : "No Filters",
        text: !bulkStatus
          ? "Please select a status."
          : "Please select at least one filter before submitting.",
        confirmButtonColor: "#f8bb86",
      });
      return;
    }

    const performedBy = user?.UserID || 0;
    const performedOn = new Date().toISOString().slice(0, 19).replace("T", " ");
    const filterIds = bulkFormData.map((f) => f.FilterId).join(", ");
    const description = auditLogDescription[bulkStatus] || "Bulk Update";
    const stage = processOrderMapping[bulkStatus];
    const currentStage =
      stageNameMapping[bulkFormData[0]?.Status || 0] || "Unknown";
    const newStage = stageNameMapping[stage] || "Unknown";

    const auditPayloadBase = {
      ActivityType: 1,
      PerformedBy: performedBy,
      PerformedOn: performedOn,
      Notes: `${
        isReauthenticated ? "Manual Override: " : ""
      }${description} for Filters: ${filterIds}`,
      Location: "washing",
    };

    // Check for missing fields
    const missingFieldSet = new Set();
    if (stage === 1) {
      if (!commonFields.washingReasonId) missingFieldSet.add("Washing Reason");
      if (!commonFields.RoWaterPressure)
        missingFieldSet.add("RO Water Pressure");
      if (!commonFields.AirPressure) missingFieldSet.add("Air Pressure");
    }
    if (stage === 3) {
      if (!commonFields.DryerEquipId) missingFieldSet.add("Dryer Equipment");
      if (!commonFields.Duration) missingFieldSet.add("Duration");
    }

    if (missingFieldSet.size > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Required Fields",
        html: Array.from(missingFieldSet).join(", "),
        confirmButtonColor: "#f8bb86",
      });
      return;
    }

    // Initialize deviation tracking
    let hasDeviation = false;
    const deviationMessages = [];

    // Check for invalid status transition (New/Spare to non-Wash In)
    const hasStatusZero = bulkFormData.some((item) => item.Status === 0);
    if (hasStatusZero && bulkStatus !== "Wash In") {
      const errorMessage = `Invalid Status Transition: Filters with 'New' status can only transition to 'Wash In'.`;
      hasDeviation = true;
      deviationMessages.push(errorMessage);
      for (const filter of bulkFormData.filter((item) => item.Status === 0)) {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            Notes: `Deviation: Status Transition - ${errorMessage}. Filter: ${filter.FilterId}`,
            IsSucces: 0,
          }),
        }).catch((err) =>
          console.error("Audit log error (Status Deviation):", err)
        );
        const notificationPayload = {
          Title: "Deviations",
          Message: `Deviation detected for Filter ${filter.FilterId}: Status Transition - ${errorMessage}`,
          RoleID: 4,
        };
        console.log("Sending notification for deviation:", notificationPayload);
        await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notificationPayload),
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.Status) {
              console.log(
                "Notification sent successfully for Filter:",
                filter.FilterId,
                notificationPayload
              );
            } else {
              console.warn(
                "Notification API failed for Filter:",
                filter.FilterId,
                result
              );
            }
          })
          .catch((err) =>
            console.error("Notification error (Status Deviation):", err)
          );
      }
      console.log("Status deviation detected:", errorMessage);
    }

    // Check sequence for each filter
    for (const filter of bulkFormData) {
      const sequenceResult = await checkStageSequence(
        filter.Barcode,
        processOrderMapping[bulkStatus],
        performedBy
      );
      if (!sequenceResult.isValid) {
        hasDeviation = true;
        deviationMessages.push(sequenceResult.message);
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            Notes: `Deviation: Cleaning Sequence - ${sequenceResult.message}. Filter: ${filter.FilterId}`,
            IsSucces: 1,
          }),
        }).catch((err) =>
          console.error("Audit log error (Sequence Deviation):", err)
        );
        const notificationPayload = {
          Title: "Deviations",
          Message: `Deviation detected for Filter ${filter.FilterId}: Cleaning Sequence - ${sequenceResult.message}`,
          RoleID: 4,
        };
        console.log("Sending notification for deviation:", notificationPayload);
        await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notificationPayload),
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.Status) {
              console.log(
                "Notification sent successfully for Filter:",
                filter.FilterId,
                notificationPayload
              );
            } else {
              console.warn(
                "Notification API failed for Filter:",
                filter.FilterId,
                result
              );
            }
          })
          .catch((err) =>
            console.error("Notification error (Sequence Deviation):", err)
          );
        console.log(
          "Sequence deviation detected for Filter:",
          filter.FilterId,
          sequenceResult.message
        );
      }
    }

    // Check dryer duration for Dry Out
    if (bulkStatus === "Dry Out") {
      for (const filter of bulkFormData) {
        const durationResult = checkDryerDuration(filter);
        if (!durationResult.isValid) {
          hasDeviation = true;
          deviationMessages.push(durationResult.message);
          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              ...auditPayloadBase,
              Notes: `Deviation: Dryer Duration - ${durationResult.message}. Filter: ${filter.FilterId}`,
              IsSucces: 0,
            }),
          }).catch((err) =>
            console.error("Audit log error (Duration Deviation):", err)
          );
          const notificationPayload = {
            Title: "Deviations",
            Message: `Deviation detected for Filter ${filter.FilterId}: Dryer Duration - ${durationResult.message}`,
            RoleID: 4,
          };
          console.log(
            "Sending notification for deviation:",
            notificationPayload
          );
          await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(notificationPayload),
          })
            .then((response) => response.json())
            .then((result) => {
              if (result.Status) {
                console.log(
                  "Notification sent successfully for Filter:",
                  filter.FilterId,
                  notificationPayload
                );
              } else {
                console.warn(
                  "Notification API failed for Filter:",
                  filter.FilterId,
                  result
                );
              }
            })
            .catch((err) =>
              console.error("Notification error (Duration Deviation):", err)
            );
          console.log(
            "Duration deviation detected for Filter:",
            filter.FilterId,
            durationResult.message
          );
        }
      }
    }

    // Check pressure values
    const pressureResult = checkPressureValues();
    if (!pressureResult.isValid) {
      hasDeviation = true;
      deviationMessages.push(pressureResult.message);
      for (const filter of bulkFormData) {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            Notes: `Deviation: Pressure Validation - ${pressureResult.message}. Filter: ${filter.FilterId}`,
            IsSucces: 0,
          }),
        }).catch((err) =>
          console.error("Audit log error (Pressure Deviation):", err)
        );
        const notificationPayload = {
          Title: "Deviations",
          Message: `Deviation detected for Filter ${filter.FilterId}: Pressure Validation - ${pressureResult.message}`,
          RoleID: 4,
        };
        console.log("Sending notification for deviation:", notificationPayload);
        await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(notificationPayload),
        })
          .then((response) => response.json())
          .then((result) => {
            if (result.Status) {
              console.log(
                "Notification sent successfully for Filter:",
                filter.FilterId,
                notificationPayload
              );
            } else {
              console.warn(
                "Notification API failed for Filter:",
                filter.FilterId,
                result
              );
            }
          })
          .catch((err) =>
            console.error("Notification error (Pressure Deviation):", err)
          );
      }
      console.log("Pressure deviation detected:", pressureResult.message);
    }

    // Prompt reauthentication if there are deviations and not already reauthenticated
    if (hasDeviation && !isReauthenticated) {
      setDeviationMessage(deviationMessages.join("; "));
      console.log(
        "Triggering reauthentication modal with message:",
        deviationMessages.join("; ")
      );
      const reauthSuccess = await promptReauthentication(
        deviationMessages.join("; ")
      );
      if (!reauthSuccess) {
        console.log("Reauthentication failed or canceled");

        return;
      }
    }

    const cleanedPayload = bulkFormData.map((filter) => ({
      FilterId: filter.ID || 0,
      StageId: stage,
      Remarks: filter.Remarks?.trim() || "",
      Status: stage,
      washingEquipId: stage === 1 ? commonFields.washingEquipId || 0 : 0,
      AirPressure: stage === 3 ? `${commonFields.AirPressure} Bar` : "",
      RoWaterPressure: stage === 1 ? `${commonFields.RoWaterPressure} Bar` : "",
      Duration: stage === 3 ? commonFields.Duration || 0 : 0,
      DryerEquipId: stage === 3 ? commonFields.DryerEquipId || "" : "",
      DryerTemp: "",
      performedBy: performedBy,
      Barcode: filter.Barcode || "",
      washingReasonId: stage === 1 ? commonFields.washingReasonId || 0 : 0,
      platform: "Web",
      Override: isReauthenticated,
      blockId: selectedBlock || 0,
    }));

    setSubmitLoading(true);
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we submit your data.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const apiUrl = isReauthenticated
        ? `${getApiBaseUrl()}/api/ManualOverride`
        : `${getApiBaseUrl()}${UPDATEFILTERSTATUS}`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cleanedPayload),
      });

      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (err) {
        console.error("Failed to parse response JSON:", err, responseText);
        throw new Error("Invalid response format from server");
      }

      console.log("Submission response:", result);

      if (!response.ok) {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            Notes: `${
              isReauthenticated ? "Manual Override: " : ""
            }${description} failed for Filters: ${filterIds}. HTTP Status: ${
              response.status
            }`,
            IsSucces: 0,
          }),
        }).catch((err) =>
          console.error("Audit log error (HTTP Failure):", err)
        );

        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const isSuccess = result.Status || result.status;
      if (isSuccess) {
        if (isReauthenticated) {
          const overrideMessage = `Deviation occurred: Transition from ${currentStage} to ${newStage} for Filters: ${filterIds}.`;
          for (const filter of bulkFormData) {
            await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ...auditPayloadBase,
                Notes: `Deviation: Override Transition - ${overrideMessage}. Filter: ${filter.FilterId}`,
                IsSucces: 0,
              }),
            }).catch((err) =>
              console.error("Audit log error (Override Deviation):", err)
            );
            const notificationPayload = {
              Title: "Deviations",
              Message: `Deviation detected for Filter ${filter.FilterId}: Override Transition - ${overrideMessage}`,
              RoleID: 4,
            };
            console.log(
              "Sending notification for deviation:",
              notificationPayload
            );
            await fetch(`${getApiBaseUrl()}/api/addNotificationsToRole`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(notificationPayload),
            })
              .then((response) => response.json())
              .then((result) => {
                if (result.Status) {
                  console.log(
                    "Notification sent successfully for Filter:",
                    filter.FilterId,
                    notificationPayload
                  );
                } else {
                  console.warn(
                    "Notification API failed for Filter:",
                    filter.FilterId,
                    result
                  );
                }
              })
              .catch((err) =>
                console.error("Notification error (Override Deviation):", err)
              );
          }
          setDeviationMessage(overrideMessage);
        }

        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            IsSucces: 1,
          }),
        }).catch((err) => console.error("Audit log error (Success):", err));

        Swal.fire({
          icon: "success",
          title: "Submitted!",
          text: `All filters updated successfully${
            isReauthenticated ? " (Manual Override)" : ""
          }.`,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          setSelectedIds([]);
          setBulkStatus("");
          setBulkFormData([]);
          setIsManualOverride(false);
          setIsReauthenticated(false);
          onClose();
          fetchFilters(setFiltersData, setLoadingFilters);
        });
      } else {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...auditPayloadBase,
            Notes: `${
              isReauthenticated ? "Manual Override: " : ""
            }${description} failed: ${
              result.ResultMessage ||
              result.Message ||
              result.message ||
              "Unknown error"
            }. Filters: ${filterIds}`,
            IsSucces: 0,
          }),
        }).catch((err) => console.error("Audit log error (API Failure):", err));

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            result.ResultMessage ||
            result.Message ||
            result.message ||
            "Something went wrong",
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...auditPayloadBase,
          Notes: `${
            isReauthenticated ? "Manual Override: " : ""
          }${description} error: ${error.message}. Filters: ${filterIds}`,
          IsSucces: 0,
        }),
      }).catch((err) => console.error("Audit log error (Catch):", err));

      console.error("Submit error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          "Something went wrong while submitting the data: " + error.message,
        confirmButtonColor: "#d33",
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const tableColumns = [
    {
      title: "Filter ID",
      dataIndex: "FilterId",
      key: "FilterId",
      width: "50%",
    },
    {
      title: "Remarks",
      dataIndex: "Remarks",
      key: "Remarks",
      width: "50%",
      render: (text, record, index) => (
        <TextArea
          rows={2}
          value={text}
          onChange={(e) => {
            setBulkFormData((prev) =>
              prev.map((data, i) =>
                i === index
                  ? { ...data, Remarks: e.target.value.trimStart() }
                  : data
              )
            );
          }}
        />
      ),
    },
  ];

  return (
    <>
      <Modal
        title="Deviation Detected"
        open={isReauthModalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={() => handleCancel(window.reauthResolve)}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={reauthLoading}
            onClick={() => handleAuthenticate(window.reauthResolve)}
          >
            Authenticate
          </Button>,
        ]}
        closable={false}
      >
        <p>Deviation: {deviationMessage} Please reauthenticate to proceed.</p>
        <Input.Password
          placeholder="Enter your password"
          value={reauthPassword}
          onChange={(e) => {
            console.log("Password input changed:", e.target.value);
            setReauthPassword(e.target.value);
          }}
          onPressEnter={() => handleAuthenticate(window.reauthResolve)}
        />
      </Modal>
      <style>
        {`
          .scrollable-table {
            max-height: ${Math.min(bulkFormData.length, 3) * 100}px;
            overflow-y: auto;
            margin-bottom: 1rem;
          }
        `}
      </style>
      <Drawer
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{`Bulk Update: ${bulkStatus || "Select Status"}`}</span>
            <div>
              <Button
                type="primary"
                onClick={handleBulkSubmit}
                loading={submitLoading}
                className="btn btn-sm btn-outline-success me-2"
              >
                <i className="fa fa-check fs-4"></i>
              </Button>
            </div>
          </div>
        }
        placement="right"
        onClose={() => {
          setBulkStatus("");
          setBulkFormData([]);
          setCommonFields({
            washingEquipId: null,
            washingReasonId: null,
            RoWaterPressure: "",
            DryerEquipId: null,
            Duration: null,
            AirPressure: "",
          });
          setIsManualOverride(false);
          setIsReauthenticated(false);
          setDeviationMessage("");
          onClose();
        }}
        open={visible}
        width={
          window.innerWidth <= 576
            ? "90%"
            : window.innerWidth <= 992
            ? "55%"
            : window.innerWidth <= 1440
            ? "35%"
            : "20%"
        }
        footer={null}
        size="large"
      >
        {submitLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", marginBottom: 8 }}>
            New Status
          </label>
          <Select
            style={{ width: "100%" }}
            value={bulkStatus}
            onChange={(value) => setBulkStatus(value)}
            placeholder="Select Status"
          >
            <Option value="">Select Status</Option>
            <Option value="Wash In">Wash In</Option>
            <Option value="Wash Out">Wash Out</Option>
            <Option value="Dry In">Dry In</Option>
            <Option value="Dry Out">Dry Out</Option>
            <Option value="Storage-In">Storage-In</Option>
            <Option value="Storage-Out">Storage-Out</Option>
          </Select>
        </div>
        <div className="scrollable-table">
          <AntTable
            columns={tableColumns}
            dataSource={bulkFormData}
            pagination={false}
            scroll={{ y: Math.min(bulkFormData.length, 3) * 100 }}
            rowKey="ID"
          />
        </div>
        {bulkStatus === "Wash In" && (
          <div className="common-fields">
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Washing Equipment
              </label>
              <Select
                showSearch
                placeholder="-- Select Equipment --"
                optionFilterProp="children"
                value={commonFields.washingEquipId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    washingEquipId: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {washingEquipments.map((equip) => (
                  <Option key={equip.Id} value={equip.Id}>
                    {equip.EquipmentName} ({equip.SerialNumber})
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Washing Reason
              </label>
              <Select
                showSearch
                placeholder="-- Select Reason --"
                optionFilterProp="children"
                value={commonFields.washingReasonId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    washingReasonId: Number(value),
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {washingReasons.map((reason) => (
                  <Option key={reason.Id} value={reason.Id}>
                    {reason.Reason}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                RO Water Pressure
              </label>
              <Select
                showSearch
                placeholder="RO Water Pressure"
                optionFilterProp="children"
                value={commonFields.RoWaterPressure || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    RoWaterPressure: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {pressureOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Air Pressure
              </label>
              <Select
                showSearch
                placeholder="Air Pressure"
                optionFilterProp="children"
                value={commonFields.AirPressure || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    AirPressure: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {airPressureSelectOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        )}
        {bulkStatus === "Dry In" && (
          <div className="common-fields">
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Dryer Equipment
              </label>
              <Select
                showSearch
                placeholder="Select Dryer Equipment"
                optionFilterProp="children"
                value={commonFields.DryerEquipId || undefined}
                onChange={(value) => {
                  setCommonFields((prev) => ({
                    ...prev,
                    DryerEquipId: value,
                  }));
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                style={{ width: "100%" }}
              >
                {dryerEquipmentOptions.map((equip) => (
                  <Option key={equip.Id} value={equip.Id}>
                    {equip.EquipmentName} ({equip.SerialNumber})
                  </Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: "block", marginBottom: 8 }}>
                Duration
              </label>
              <Input
                type="number"
                placeholder="Enter duration"
                value={commonFields.Duration || ""}
                onChange={(e) => {
                  const num = parseInt(e.target.value, 10) || null;
                  setCommonFields((prev) => ({
                    ...prev,
                    Duration: num,
                  }));
                }}
                addonAfter="min"
                size="middle"
              />
            </div>
          </div>
        )}
        {deviationMessage && (
          <div style={{ color: "red", marginBottom: 16 }}>
            {deviationMessage}
          </div>
        )}
      </Drawer>
    </>
  );
};

BulkUpdateOffcanvas.propTypes = {
  selectedIds: PropTypes.arrayOf(
    PropTypes.shape({
      FilterId: PropTypes.string.isRequired,
      ID: PropTypes.number.isRequired,
      Status: PropTypes.number.isRequired,
      Barcode: PropTypes.string,
      LastCleaningDate: PropTypes.string,
      cleaningdays: PropTypes.number,
      Lable: PropTypes.string.isRequired,
    })
  ).isRequired,
  setSelectedIds: PropTypes.func.isRequired,
  fetchFilters: PropTypes.func.isRequired,
  setFiltersData: PropTypes.func.isRequired,
  setLoadingFilters: PropTypes.func.isRequired,
  selectedBlock: PropTypes.number,
  isManualOverride: PropTypes.bool.isRequired,
  setIsManualOverride: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BulkUpdateOffcanvas;
